import MessageApi from '../../../../api/inbox/message';

export default {
  async forwardMessage(_, { conversationId, messageIds, contacts }) {
    await MessageApi.forwardMessage(conversationId, messageIds, contacts);
  },
};
